import {
  renderRequiredRule,
  renderValidator,
  renderLengthFieldRule,
  checkValidityInn,
} from "@/utils/renderRulesForm";

export default (thirdPerson) => ({
  cargoTransportationCustomer: [
    renderRequiredRule("Пожалуйста выберите заказчика"),
    {
      validator: (rule, value, callback) => {
        if (thirdPerson.cargoTransportationCustomer && value === "") {
          callback(new Error("Пожалуйста выберите заказчика"));
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  typeThirdPerson: [],
  innThirdPerson: [
    renderRequiredRule("Пожалуйста введите ИНН"),
    renderValidator({
      validatorFunc: (value) => {
        return checkValidityInn(value);
      },
      message: "Некорректно введён ИНН",
    }),
    renderLengthFieldRule({
      min: 10,
      max: 12,
      message: "ИНН должен состоять от 10 до 12 символов",
    }),
  ],
  name: [
    renderRequiredRule("Пожалуйста введите название организации"),
  ],
  surnameThirdPerson: [
    renderRequiredRule("Введите фамилию"),
    renderValidator({
        validatorFunc: (value) =>
        (value.length >= 2),
        message: "Слишком коротко",
    }),
  ],
  firstNameThirdPerson: [
    renderRequiredRule("Введите имя"),
    renderValidator({
        validatorFunc: (value) =>
        (value.length >= 1),
        message: "Слишком коротко",
    }),
  ],
  secondNameThirdPerson: [
    renderRequiredRule("Введите отчество"),
    renderValidator({
        validatorFunc: (value) =>
        (value.length >= 1),
        message: "Слишком коротко",
    }),
  ],
  phoneThirdPerson: [
    renderRequiredRule("Введите телефон"),
    renderValidator({
      validatorFunc: (value) =>
        !!value.match(/^\+{0,1}\d \([3,4,6-9]\d{2}\) \d{3}-\d{2}-\d{2}$/),
      message: "Некорректно введён номер",
    }),
  ],
  emailThirdPerson: [
    {
      validator: (rule, value, callback) => {
        if (
          (thirdPerson.typeThirdPerson && (value === "")) ||
          (!(value === "") && !value.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+$/))
        ) {
          callback(new Error("Пожалуйста введите почту"));
        } 
        callback();
      },
      trigger: "blur",
    },
  ],
});
